import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ButtonLogoutModal from '../ButtonLogoutModal';
import logo from '../../assets/logo.png';
import styles from './styles.module.scss';
import user from '../../assets/User.svg';

const Header = ({firstName}) => (
  <div className={styles.headerDesktop}>
    <div className={styles.sideBar}>
      <img src={logo} alt="Atzmai logo" className={styles.logo}/>
      {firstName && (
        <div className={styles.usernameContainer}>
          <img src={user} alt="user" className={styles.userpic}/>
          <div className={styles.username}>
            <FormattedMessage
              id="common-hello-label"
              defaultMessage="Hello, {username}"
              values={{username: firstName}}
            />
          </div>
        </div>
      )}
    </div>
    <div className={styles.logout}>
      <ButtonLogoutModal/>
    </div>
  </div>
);

Header.propTypes = {
  firstName: PropTypes.string,
};

export default Header;
